<template>
  <WsMain>
    <WsCRUD
      :modelName="modelName"
      :label="label"
      :fields="fields"
      :liveSearching="true"
      :sortBy="sortBy"
      :showFields="showFields"
    ></WsCRUD>
  </WsMain>
</template>

<script>
import model from "@/models/act_type";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    fields: model.fields,
    showFields: [
      "sequence",
      "name",
      "icon",
      "area",
      "updated_at",
      "updated_admin",
    ],
    liveSearching: true,
    sortBy: "sequence",
  }),
};
</script>